import createTheme from '@mui/material/styles/createTheme';

const font = {
  regular: 'almoni-regular',
  bold: 'almoni-bold',
  medium: 'almoni-demibold',
  light: 'almoni-light',
};

export const theme = () =>
  createTheme({
    direction: 'rtl',
    typography: {
      htmlFontSize: 10,
      fontFamily: font.bold,
      stepTitle: {
        fontFamily: font.regular,
        fontSize: '4.0rem',
        lineHeight: '4.38rem',
      },
      stepSubTitle: {
        fontFamily: font.regular,
        fontSize: '1.8rem',
        lineHeight: '1.97rem',
      },
    },
    palette: {
      mode: 'dark',
      primary: {
        main: '#2F80ED',
      },
      error: {
        main: '#E42323',
      },
      background: {
        default: '#142c51',
        paper: '#114E71',
      },
    },
  });

export default theme;
